export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-scale/src/number.js
// module id = /bJz
// module chunks = 0